/*Accounting report*/
if (window.location.pathname.includes("reports/accounting")) {
    var timeout;
    $.each($(".data-table"), function() {
        $(this).data("options", window.app.datatableOptions).on('change', '.dropdown-field', function() {
            const id = $(this).data('id');
            const value = $(this).find(':selected').val();
            const field = $(this).attr('name');
            const options = $(this).data('options');
            const sorter = $(this).parent().find('.field-sorter');

            $.ajax({
                url: '/api/placement/fill',
                method: 'post',
                data: { id, [field]: value },
                dataType: 'json',
                success: function(response) {
                    const sort = window.app_options[options].find((u) => u.id == value);
                    sorter.text(sort ? sort.text : '');
                    message("Successfully updated placement.");
                    window.notification_worker();
                },
                error: function(response) {
                    message("Error updating placement.", 1);
                }
            })
        }).on('change', '.accounting-archive', function() {
            const id = $(this).data('id');
            const value = $(this).is(":checked");

            $.ajax({
                url: '/api/placement/update',
                method: 'post',
                data: { id, archived: value ? 1 : 0 },
                dataType: 'json',
                success: function(response) {
                    message(response.message);
                    window.notification_worker();
                },
                error: function(response) {
                    message("Error archiving placement.", 1);
                }
            })
        }).on('keyup', '.update-accounting-notes', function() {
            const el = $(this);
            clearTimeout(timeout);

            timeout = setTimeout(function() {
                const id = el.data('id');
                const value = el.val();
                const field = el.attr('name');

                $.ajax({
                    url: '/api/placement/fill',
                    method: 'post',
                    data: { id, [field]: value },
                    dataType: 'json',
                    success: function(response) {
                        message("Successfully updated placement.");
                        window.notification_worker();
                    },
                    error: function(response) {
                        message("Error updating placement.", 1);
                    }
                })
            }, 500);
        });;
    });

    const handlePolicyholderSearch = _.debounce(function () {
        const search = $(this).val();

        $(".dataTable").each(function () {
            const table = $(this);
            const tableInstance = table.DataTable();

            if (search !== false) {
                tableInstance.columns(0).search(search).draw();
            } else {
                tableInstance.columns.adjust().draw();
            }
        });
    }, 100);

    $("[name='policyholder_search']").on("keyup", handlePolicyholderSearch);

    $(window).on("tableLoaded", function(event, table) {
        $("[name='policyholder_search']").trigger("keyup");
        $("div.closed-lost").html('<h4 class="pt-2 px-1">Closed Lost</h4>');
        $("div.moved-out").html('<h4 class="pt-2 px-1">Placements Moved Out</h4>');
        $("div.frv-only").html('<h4 class="pt-2 px-1">FRV Only</h4>');
        $("div.hotel-only").html('<h4 class="pt-2 px-1">Hotel Only</h4>');
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/accounting.js